import type { AssessmentSummary } from "@/types";

export const mockAssessments: AssessmentSummary[] = [
  {
    id: "sess_demo_001",
    title: "Q1 Cloud spend review",
    status: "active",
    updatedAt: "2026-04-05T14:22:00.000Z",
  },
  {
    id: "sess_demo_002",
    title: "Kubernetes rightsizing",
    status: "draft",
    updatedAt: "2026-04-04T09:10:00.000Z",
  },
  {
    id: "sess_demo_003",
    title: "Reserved instances audit",
    status: "completed",
    updatedAt: "2026-03-28T11:45:00.000Z",
  },
];
